import { defineStore } from 'pinia'

import state from './state'
import actions from './actions'

const useHomeConfigurationStore = defineStore('homeConfiguration', {
  state,
  actions
})

export default useHomeConfigurationStore
